<form class="grid-container grid-3" [formGroup]="formGroup">
    <ui-form-field class="grid-span-3" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.COLUMNS' | translate">
        <ui-selectable-chips
            labelField="name"
            formControlName="columns"
            groupField="resourceTypeLabel"
            [isDeletable]="true"
            [options]="columnMembers$ | async"
        >
            <ng-template let-option="option">{{ option.name }}</ng-template>
        </ui-selectable-chips>
    </ui-form-field>

    <ui-form-field class="grid-row-2" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.SORT_BY' | translate">
        <ui-select
            formControlName="sortMemberCode"
            labelField="name"
            valueField="memberCode"
            groupField="resourceTypeLabel"
            [options]="formGroup.value.columns"
            [disabled]="!formGroup.value.columns?.length || disabled"
            [clearable]="true"
        />
    </ui-form-field>

    <ui-toggle
        class="grid-row-2 toggle"
        formControlName="isSortReversed"
        [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.TOGGLE_REVERSE_SORT' | translate"
    />

    <ui-form-field class="grid-row-3" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.TABLE_LIMIT' | translate">
        <input advizeoInput type="number" min="1" step="1" formControlName="limit" [max]="DEFAULT_LIMIT" />
    </ui-form-field>

    <ui-toggle
        class="grid-span-3 toggle"
        formControlName="displayLinesWithNullValues"
        [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.DISPLAY_NULL_VALUES' | translate"
    />
</form>
